import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_2 = { class: "inline-flex items-baseline q-mb-xs" }
const _hoisted_3 = { class: "pos-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_item_addition_component = _resolveComponent("item-addition-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_parameter_inline_display = _resolveComponent("parameter-inline-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.id > 0 && !_ctx.hideInfoBtn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_app_tooltip, {
                text: _ctx.$t('info'),
                style: { height: '18px' }
              }, {
                activator: _withCtx(() => [
                  _createVNode(_component_app_icon, {
                    class: "pos-row__info q-mr-xs",
                    name: "info-circle-outline",
                    width: "18px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPosInfoMode = true))
                  })
                ]),
                _: 1
              }, 8, ["text"]),
              _createVNode(_component_q_dialog, {
                modelValue: _ctx.showPosInfoMode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPosInfoMode) = $event)),
                "no-shake": "",
                "full-width": !_ctx.isMobile,
                maximized: _ctx.isMobile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_item_addition_component, {
                    "existing-position-id": _ctx.id,
                    "read-only": _ctx.readOnly,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPosInfoMode = false))
                  }, null, 8, ["existing-position-id", "read-only"])
                ]),
                _: 1
              }, 8, ["modelValue", "full-width", "maximized"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_parameter_inline_display, {
          id: 'ds_' + _ctx.id,
          editable: false,
          "is-table": false,
          "model-value": _ctx.el
        }, null, 8, ["id", "model-value"])
      ]),
      (!_ctx.hideRemoveBtn)
        ? (_openBlock(), _createBlock(_component_app_tooltip, {
            key: 0,
            text: _ctx.$t('remove'),
            style: { height: '16px' }
          }, {
            activator: _withCtx(() => [
              _createVNode(_component_app_icon, {
                class: "ml-1 pos-row__remove",
                name: "close",
                width: "16px",
                color: "#979797",
                "hover-color": "#616161",
                cursor: "pointer",
                onClick: _withModifiers(_ctx.detach, ["stop"])
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}